var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-wrapper",staticStyle:{"width":"100%","height":"100%"}},[_c('div',{ref:"genderchart",staticClass:"chart",staticStyle:{"width":"100%","height":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }